import React from 'react';
import { AIAgentCapabilityConfig } from '@troia-v3/types';
import { useFunnels } from '@/modules/funnels/hooks/useFunnels';
import { Icon } from '@/shared/icons'
interface LeadManagementConfigProps {
  config: AIAgentCapabilityConfig | undefined;
  onChange: (config: AIAgentCapabilityConfig) => void;
}

export const LeadManagementConfig: React.FC<LeadManagementConfigProps> = ({
  config,
  onChange
}) => {
  const isEnabled = config?.enabled || false;
  const funnelId = config?.config?.funnelId || '';

  const { data: funnelsData, isLoading } = useFunnels({ limit: 100 });

  const handleToggleEnabled = (enabled: boolean) => {
    onChange({
      capability: 'lead_management',
      enabled,
      config: config?.config || {}
    });
  };

  const handleFunnelChange = (selectedFunnelId: string) => {
    onChange({
      capability: 'lead_management',
      enabled: isEnabled,
      config: {
        ...config?.config,
        funnelId: selectedFunnelId
      }
    });
  };

  return (
    <div className="space-y-4">
      {/* Header com Toggle */}
      <div
        className="p-4 rounded-lg border"
        style={{
          backgroundColor: 'var(--theme-card-background)',
          borderColor: 'var(--theme-card-border)',
        }}
      >
        <div className="flex items-start gap-3">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{
              backgroundColor: 'var(--theme-primary-background)',
              color: 'var(--theme-primary)',
            }}
          >
            <Icon name="trending-up" className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between mb-2">
              <h4
                className="text-sm font-semibold"
                style={{ color: 'var(--theme-card-text)' }}
              >
                Gerenciamento de Leads
              </h4>
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={isEnabled}
                  onChange={(e) => handleToggleEnabled(e.target.checked)}
                  className="w-4 h-4"
                  style={{ accentColor: 'var(--theme-primary)' }}
                />
                <span
                  className="text-xs font-medium"
                  style={{ color: 'var(--theme-card-text)' }}
                >
                  {isEnabled ? 'Habilitado' : 'Desabilitado'}
                </span>
              </label>
            </div>
            <p
              className="text-xs"
              style={{ color: 'var(--theme-muted-text)' }}
            >
              Permite que o agente crie leads durante as conversas
            </p>
          </div>
        </div>
      </div>

      {/* Configurações (apenas se habilitado) */}
      {isEnabled && (
        <div className="space-y-4">
          {/* Seleção de Funil */}
          <div>
            <label
              className="block text-xs mb-2 font-medium"
              style={{ color: 'var(--theme-card-text)' }}
            >
              Funil
            </label>
            <p
              className="text-xs mb-3"
              style={{ color: 'var(--theme-muted-text)' }}
            >
              Selecione o funil onde os leads serão criados. Se nenhum funil for selecionado, leads serão criados sem funil.
            </p>

            <select
              value={funnelId}
              onChange={(e) => handleFunnelChange(e.target.value)}
              className="w-full h-[38px] px-3 py-2 rounded-lg border text-sm"
              style={{
                backgroundColor: 'var(--theme-input-background)',
                borderColor: 'var(--theme-input-border)',
                color: 'var(--theme-input-text)'
              }}
              disabled={isLoading}
            >
              <option value="">Sem funil (opcional)</option>
              {funnelsData?.items.map((funnel) => (
                <option key={funnel.id} value={funnel.id}>
                  {funnel.name}
                </option>
              ))}
            </select>

            {!funnelId && (
              <p
                className="text-xs mt-2"
                style={{ color: 'var(--theme-info-color)' }}
              >
                ℹ️ Leads serão criados sem etapa de funil. A atribuição será baseada nas regras do funil selecionado.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
